class Slideshow extends HTMLElement {
  constructor() {
    super();
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  get autoSlideStatus() {
    return this.dataset.autoSlide;
  }

  get autoSlideInterval() {
    return this.dataset.autoSlideInterval;
  }

  connectedCallback() {
    this.slider = this.querySelector(`#slideshow__slider-${this.sectionId}`);
    this.leftArrow = this.querySelector(`#slideshow__left-arrow-${this.sectionId}`);
    this.rightArrow = this.querySelector(`#slideshow__right-arrow-${this.sectionId}`);

    this.maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;
    // set default arrow visibility
    if (this.slider.scrollLeft === 0) {
      this.leftArrow.dataset.visibility = 'hidden';
      this.rightArrow.dataset.visibility = 'show';
    } else if (this.slider.scrollLeft >= this.maxScrollLeft - 1) {
      this.rightArrow.dataset.visibility = 'hidden';
      this.leftArrow.dataset.visibility = 'show';
    }


    this.handleClick = this.handleClick.bind(this);

    this.slider.addEventListener('scroll', this.handleClick);
    this.leftArrow.addEventListener('click', this.handleClick);
    this.rightArrow.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.slider.removeEventListener('scroll', this.handleClick);
    this.leftArrow.removeEventListener('click', this.handleClick);
    this.rightArrow.removeEventListener('click', this.handleClick);
  }

  _scrollSlider() {

  }

  handleClick(e) {
    // scroll the slider if one of the arrow is clicked
    if (e.type === 'click') {
      const isLeft = e.target === this.leftArrow || this.leftArrow.contains(e.target);
      const isRight = e.target === this.rightArrow || this.rightArrow.contains(e.target);

      if (isLeft) {
        const currentLeft = this.slider.scrollLeft;
        const targetLeft = Math.max(0, currentLeft - this.slider.clientWidth);
        this.slider.scroll({ left: targetLeft, behavior: 'smooth' });
      } else if (isRight) {
        const currentLeft = this.slider.scrollLeft;
        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        const targetLeft = Math.min(maxScroll, currentLeft + this.slider.clientWidth);
        this.slider.scroll({ left: targetLeft, behavior: 'smooth' });
      }
    }

    // hide the arrows based on slider scrollLeft and maxScrollLeft
    // triggered for mouse scroll or arrow clicks
    if (this.slider.scrollLeft === 0) {
      this.leftArrow.dataset.visibility = 'hidden';
      this.rightArrow.dataset.visibility = 'show';
    } else if (this.slider.scrollLeft >= this.maxScrollLeft - 1) {
      this.rightArrow.dataset.visibility = 'hidden';
      this.leftArrow.dataset.visibility = 'show';
    } else {
      this.rightArrow.dataset.visibility = 'show';
      this.leftArrow.dataset.visibility = 'show';
    }
  }

  autoSlide() {

  }
}

customElements.define('slide-show', Slideshow);
